export default {"src":"/_next/static/media/card-discover.1eed3a16.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};